import { useEffect } from "react";
import AuthStore from "../stores/AuthStore";

/**
 * Apply theme to HTML element
 */
export const applyTheme = (themeMode) => {
  const htmlElement = document.documentElement;
  
  // Remove existing theme classes
  htmlElement.classList.remove("dark", "light");
  
  if (themeMode === "system") {
    // Use system preference
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (prefersDark) {
      htmlElement.classList.add("dark");
    } else {
      htmlElement.classList.add("light");
    }
  } else {
    // Apply specific theme
    htmlElement.classList.add(themeMode);
  }
  
  // Store in localStorage for persistence
  localStorage.setItem("themeMode", themeMode);
};

/**
 * Initialize theme on app load
 */
export const initializeTheme = () => {
  const user = AuthStore.user;
  const savedTheme = localStorage.getItem("themeMode");
  const themeMode = user?.themeMode || savedTheme || "system";
  applyTheme(themeMode);
};

/**
 * Hook to manage theme
 */
export const useTheme = () => {
  useEffect(() => {
    // Initialize theme on mount
    initializeTheme();
    
    // Listen for system theme changes if using system mode
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleSystemThemeChange = () => {
      const user = AuthStore.user;
      const themeMode = user?.themeMode || localStorage.getItem("themeMode") || "system";
      if (themeMode === "system") {
        applyTheme("system");
      }
    };
    
    mediaQuery.addEventListener("change", handleSystemThemeChange);
    
    return () => {
      mediaQuery.removeEventListener("change", handleSystemThemeChange);
    };
  }, []);
  
  return {
    applyTheme,
  };
};

